export default __webpack_public_path__ + "static/media/artback.038b31f7.jpg";